export default "__VITE_ASSET__102afb99__"